import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { focusField } from '@/utils/focus';

export const ClickableDescription: React.FC<{ children: string }> = ({ children }) => {
  const [clickedField, setClickedField] = useState<string | null>(null);

  const fieldMap: Record<string, string> = {
    'Recurring Deadline': 'recurring-meal-window',
    'Credit Interval': 'surcharge-cadence-credit',
    'Additional Offset': 'use-escalation',
    'Step-Up Deadline': 'escalation-threshold-minutes',
    'Time Credit': 'credit-extra-time-minutes',
    'Meal Break Deadline': 'meal-window-threshold',
    'Meal Break Length': 'meal-break-length',
    'Grace Period': 'grace-period'
  };

  const handleCodeClick = (fieldName: string) => {
    setClickedField(fieldName);
    setTimeout(() => setClickedField(null), 300);
    const fieldId = fieldMap[fieldName];
    if (fieldId) focusField(fieldId);
  };

  const parts = children.split(/(`[^`]+`)/g);

  return (
    <p className="text-[12px] sm:text-[13px] text-muted-foreground mt-1">
      {parts.map((part, index) => {
        if (part.startsWith('`') && part.endsWith('`')) {
          const content = part.slice(1, -1);

          if (fieldMap[content]) {
            return (
              <code
                key={index}
                className={cn(
                  'bg-muted/50 text-primary px-1 py-0.5 rounded text-xs font-mono cursor-pointer hover:bg-primary/20 transition-all duration-200',
                  clickedField === content && 'bg-primary/20 scale-110'
                )}
                style={{ display: 'inline-block' }}
                onClick={() => handleCodeClick(content)}
              >
                {content}
              </code>
            );
          }
          return (
            <code key={index} className="bg-muted/50 text-primary px-1 py-0.5 rounded text-xs font-mono">
              {content}
            </code>
          );
        }
        return part;
      })}
    </p>
  );
};
